import { create, show, useModal } from "@ebay/nice-modal-react";
import { useState } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

type DeleteConfirmationProps = {
  id: string;
  onDelete: (id: string) => Promise<string | undefined>;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  id,
  onDelete,
}: DeleteConfirmationProps) {
  const { reportSuccess } = useTypedContext(FlashContext);
  const [loading, setLoading] = useState(false);
  const modal = useModal();

  const handleDelete = async () => {
    try {
      setLoading(true);
      const deletedId = await onDelete(id);
      if (deletedId) {
        reportSuccess({ message: `Config ${deletedId} successfully deleted` });
        modal.hide();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DeleteConfirmationModal
      title="Delete config"
      name={id}
      onConfirm={handleDelete}
      isLoading={loading}
      isDismissable={!loading}
    />
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
